import { styled } from "@mui/material";
import React from "react";
const classes = {
    root: "dialog-header-root"
};
const StyledDiv = styled("div")(({ theme }) => ({
    [`&.${classes.root}`]: { fontSize: theme.typography.pxToRem(18), fontWeight: 600, margin: "auto 0" }
}));
export const DialogHeader = (props) => {
    return (React.createElement(StyledDiv, { className: classes.root, id: props.id }, props.children));
};
